<template>
	<div class="download">
		<div class="banner"></div>


		<div class="main">

			<div class="left">
				<transition name="LeftIn">
					<img v-show="text" class="text" src="../assets/images/download_text.png" width="410" height="199" />
				</transition>
				<transition name="BottomIn">
					<div class="phone" v-show="phone">
						<img src="../assets/images/download_scr_1.png" width="270" height="507" />
					</div>
				</transition>
				<transition name="FadeIn">
					<img class="point" v-show="point" src="../assets/images/download_point.png" width="250" height="250" />
				</transition>
				<transition name="FadeIn">
					<img class="point_1" v-show="point1" src="../assets/images/download_point_1.png" width="124" height="124" />
				</transition>
			</div>

			<div class="right">
				<transition name="BottomIn">
					<ul class="info" v-show="info">
						<li>
							<img src="../assets/images/index_icon_1.png" width="50" height="50" />
							<i></i>
							<div class="text">
								<p>先买后付</p>
								<span>先买后付款</span>
							</div>
						</li>
						<li style="margin: 0 48px;">
							<img src="../assets/images/index_icon_2.png" width="50" height="50" />
							<i></i>
							<div class="text">
								<p>零负担购</p>
								<span>四期免息无压力</span>
							</div>
						</li>
						<li>
							<img src="../assets/images/index_icon_3.png" width="50" height="50" />
							<i></i>
							<div class="text">
								<p>无忧操作</p>
								<span>账单到期自动还</span>
							</div>
						</li>
					</ul>
				</transition>
				<transition name="BottomIn">
					<div class="title" v-show="title">
						<p>即刻体验青柠买单</p>
						<div class="line"></div>
						<img src="../assets/images/download_title_text.png" width="322" height="37" style="margin-left: -161px;" />
					</div>
				</transition>
				<transition name="BottomIn">
					<div class="code" v-show="code">
						<div class="weixin">
							<div class="pic">即将上线</div>
							<div class="btm">
								<img src="../assets/images/download_weixin.png" width="28" height="23" />
								<p>扫码打开<br />微信小程序</p>
							</div>
						</div>
						<div class="app">
							<div class="btn">
								<div class="item">
									<img @click="change(1)" :class="{active:num ===1}" src="../assets/images/download_appstore.png" width="172"
									 height="56" />
								</div>
								<div class="item">
									<img @click="change(2)" :class="{active:num ===2}" src="../assets/images/download_android.png" width="172"
									 height="56" />
								</div>
							</div>
							<i></i>
							<div class="pic">即将上线</div>
						</div>
					</div>
				</transition>
				
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				num: 1,
				text: false,
				phone: false,
				point:false,
				point1:false,
				info:false,
				title:false,
				code:false,
			}
		},
		created() {

		},
		mounted() {
			this.text = true
			setTimeout(() => {
				this.phone = true
			}, 500);
			setTimeout(() => {
				this.point = true
			}, 800);
			setTimeout(() => {
				this.point1 = true
			}, 1100);
			setTimeout(() => {
				this.info = true
			}, 1400);
			setTimeout(() => {
				this.title = true
			}, 1700);
			setTimeout(() => {
				this.code = true
			}, 2100);
		},
		computed: {

		},
		watch: {},
		methods: {
			change(index) {
				this.num = index
			},
		},
		components: {}
	}
</script>

<style scoped lang="less">
	@keyframes move {
		0% {
			transform: translateY(0px);
		}
	
		50% {
			transform: translateY(10px);
		}
	
		100% {
			transform: translateY(0px);
		}
	}
	@keyframes scale {
		0% {
			transform: scale(1);
		}
	
		50% {
			transform: scale(1.2);
		}
	
		100% {
			transform: scale(1);
		}
	}
	.code {
		display: flex;
		align-items: center;
		justify-content: center;

		.weixin {
			width: 163px;
			height: 211px;
			background: #FFFFFF;
			box-shadow: -1px 10px 14px 0px #F0F2F4;
			border-radius: 14px;
			margin-right: 23px;
			padding-top: 15px;
			box-sizing: border-box;

			.pic {
				background: #f5f5f5;
				width: 124px;
				height: 124px;
				display: flex;
				align-items: center;
				justify-content: center;
				margin: 0 auto 12px auto;
				color: #b2b2b2;
			}

			.btm {
				width: 124px;
				margin: 0 auto;
				display: flex;
				align-items: flex-start;

				p {
					font-size: 15px;
					color: #3B4664;
					line-height: 1.2;
					font-weight: 500;
					padding-left: 10px;
				}
			}
		}

		.app {
			width: 469px;
			height: 211px;
			background: #FFFFFF;
			box-shadow: -1px 10px 14px 0px #F0F2F4;
			border-radius: 14px 68px 14px 14px;
			display: flex;
			align-items: center;
			padding-left: 40px;
			box-sizing: border-box;

			.btn {
				.item {
					margin-bottom: 15px;

					&:last-child {
						margin-bottom: 0px;
					}

					img {
						-webkit-filter: grayscale(100%);
						-moz-filter: grayscale(100%);
						-ms-filter: grayscale(100%);
						-o-filter: grayscale(100%);
						filter: grayscale(100%);
						filter: gray;
						cursor: pointer;
						display: block;

						&.active {
							-webkit-filter: grayscale(0%);
							-moz-filter: grayscale(0%);
							-ms-filter: grayscale(0%);
							-o-filter: grayscale(0%);
							filter: grayscale(0%);
							filter: gray;
						}
					}
				}
			}

			i {
				width: 1px;
				height: 90px;
				background: #EDEDED;
				margin: 0 34px;
			}

			.pic {
				background: #f5f5f5;
				width: 130px;
				height: 130px;
				display: flex;
				align-items: center;
				justify-content: center;
				color: #b2b2b2;
			}
		}
	}

	.title {
		position: relative;
		margin-bottom: 30px;

		img {
			position: absolute;
			z-index: 1;
			left: 50%;
			top: -14px;
		}

		p {
			position: relative;
			z-index: 2;
			font-size: 24px;
			font-weight: 500;
			color: #162E6B;
			text-align: center;
			line-height: 1;
			margin-bottom: 12px;
		}

		.line {
			position: relative;
			margin: 0 auto;
			z-index: 2;
			height: 1px;
			width: 367px;
			background: #fff;

			&::before {
				content: '';
				position: absolute;
				left: 50%;
				margin-left: -13px;
				top: -4px;
				width: 26px;
				height: 8px;
				background: #FFFFFF;
				border-radius: 4px;
			}
		}
	}

	.download {
		padding-top: 56px;
	}

	.banner {
		height: 448px;
		background: url(../assets/images/download_bg.png) no-repeat;
		background-size: cover;
	}

	.main {
		width: 1100px;
		margin: -420px auto 0 auto;
		display: flex;

		.left {
			width: 371px;
			height: 670px;
			position: relative;

			.text {
				position: absolute;
				z-index: 1;
				top: 310px;
				left: -150px;
			}

			.point {
				position: absolute;
				z-index: 3;
				top: 40px;
				right: -100px;
				-webkit-animation: move 2s infinite;
				-moz-animation: move 2s infinite;
				-ms-animation: move 2s infinite;
				animation: move 2s infinite;
			}

			.point_1 {
				position: absolute;
				z-index: 3;
				bottom: -10px;
				left: -16px;
				-webkit-animation: scale 3s infinite;
				-moz-animation: scale 3s infinite;
				-ms-animation: scale 3s infinite;
				animation: scale 3s infinite;
			}

			.phone {
				position: relative;
				z-index: 2;
				width: 371px;
				height: 670px;
				background: url(../assets/images/download_iphone.png) no-repeat;
				background-size: contain;

				img {
					display: block;
					margin: 0 auto;
					position: relative;
					top: 52px;
				}
			}
		}

		.right {
			width: 800px;
			padding-top: 170px;

			.info {
				margin-bottom: 55px;
				display: flex;
				justify-content: center;

				li {
					display: flex;
					align-items: center;
					color: #fff;

					i {
						width: 1px;
						height: 16px;
						background: #fff;
						margin: 0 15px;
					}

					.text {
						p {
							font-size: 20px;
							font-weight: 500;
							letter-spacing: 7px;
							text-shadow: 0px 0px 4px rgba(0, 0, 0, 0.13);
						}

						span {
							font-size: 15px;
							text-shadow: 0px 0px 4px rgba(0, 0, 0, 0.13);
							letter-spacing: 2px;
						}
					}

				}
			}
		}
	}
</style>
